/* eslint-disable */
import React, { Component } from 'react';
import Modal from 'react-modal';

export default class ResolveCaseModal extends Component {
    onRequestClose = () => {
        this.props.onRequestClose();
    };

    closeCase() {
        this.props.updateCaseStatus(
            this.props.actioned.stateName,
            this.props.actioned.index,
            'close',
            this.props.actioned.notification,
            this.inputText.value,
        );
    }

    render() {
        const style = {
            maxWidth: '600px',
            padding: 0,
            borderStyle: 'none',
            borderRadius: '20px',
        };

        return (
            <Modal
                onRequestClose={this.onRequestClose}
                contentLabel="Resolve Case Modal"
                isOpen={this.props.isOpen}
                style={{
                    content: style,
                }}
            >
                <div className="resolve-case-modal">
                    <h1>Resolve Case</h1>
                    <h2>Case</h2>
                    {this.props.actioned.notification ? (
                        <label>
                            {this.props.actioned.notification.message}
                        </label>
                    ) : null}
                    <h2>Comment</h2>
                    <label htmlFor="commentbox">
                        Information about this case
                    </label>
                    <textarea
                        name="link"
                        ref={inputText => (this.inputText = inputText)}
                        id="commentbox"
                    />
                    <div className="modal-bottom-bar">
                        <button
                            className="table-action-button"
                            onClick={() => this.closeCase()}
                        >
                            Resolve Case
                        </button>
                        <button
                            className="table-action-button table-action-button-secondary"
                            onClick={() => this.onRequestClose()}
                        >
                            {' '}
                            Cancel
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}
